import { IsIn, IsOptional, IsString, MaxLength } from "class-validator";
import { Constants } from "@eagerdog/constants";

// ----------
export class UpdateShowStatusDto {
  @IsIn(Object.values(Constants.trial_status))
  show_status: string;

  @IsOptional()
  @IsString()
  @MaxLength(50)
  show_status_note?: string;
}
